import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-workshop',
    templateUrl: './workshop.component.html',
    styleUrls: ['./workshop.component.scss'],
    standalone: false
})
export class WorkshopComponent implements OnInit {


  constructor() { }

  ngOnInit(): void {
  }

}
